import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestSocialSources } from "./socialSources.request";
import { SocialSourcesResponse } from "./socialSources.types";

const useSocialSources = (
  options?: QueryOptions<SocialSourcesResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["socialSources"],
    queryFn: requestSocialSources,
    onError: toastServerError,
    ...options
  });

  return { socialSources: data, ...rest };
};

export default useSocialSources;
